module.exports = __webpack_public_path__ + "img/logo_kesling_old.984affd7.png";